/** PostHog Cloud EU ingestion host. */
export const POSTHOG_EU_API_HOST = 'https://eu.i.posthog.com';
